export const LOGGED_IN = 'LOGGED_IN'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGGIN_TYPING = 'LOGGIN_TYPING'



// WEBPACK FOOTER //
// ./src/redux/types/userTypes.js